/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

export class BeforeLeave {
    private static instance: BeforeLeave;
    private scopes: Record<string, boolean> = {};
    public isListenerExist = false;

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    private constructor() {}

    public static getInstance(): BeforeLeave {
        if (!BeforeLeave.instance) {
            BeforeLeave.instance = new BeforeLeave();
        }

        return BeforeLeave.instance;
    }

    private beforeUnloadHandler(event: BeforeUnloadEvent) {
        event.preventDefault();
        event.returnValue = '';
    }

    private addHandler() {
        this.isListenerExist = true;

        window.addEventListener('beforeunload', this.beforeUnloadHandler);
    }

    private removeHandler() {
        this.isListenerExist = false;

        window.removeEventListener('beforeunload', this.beforeUnloadHandler);
    }

    public show(scopeName: string) {
        if (!scopeName) {
            console.error('No scopeName');
            return false;
        }

        if (!this.hasScope(scopeName)) {
            this.scopes[scopeName] = true;
        }

        if (!this.isListenerExist) {
            this.addHandler();
        }

        return true;
    }

    public hide(scopeName: string) {
        if (!scopeName) {
            console.error('No scopeName');
            return false;
        }

        if (this.hasScope(scopeName)) {
            delete this.scopes[scopeName];
        }

        if (Object.keys(this.scopes).length === 0) {
            this.removeHandler();
        }

        return true;
    }

    public hideAll() {
        Object.keys(this.scopes).forEach(scope => this.hide(scope));
    }

    public isBeforeLeaveActive() {
        return Object.keys(this.scopes).length > 0;
    }

    public hasScope(scopeName: string): boolean {
        return !!this.scopes[scopeName];
    }

    public hasNamespaceScope(namespace: string): boolean {
        return Object.keys(this.scopes).some(key => key.startsWith(namespace));
    }
}
